// ─── Shared formatting utilities ──────────────────────────────────────

/** Time-only: "14:30" */
export const formatTime = (ts: number | null): string =>
  ts
    ? new Date(ts).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";

/** Short date: "05.01.2025" */
export const formatDate = (ts: number | null): string | null => {
  if (!ts) return null;
  const d = new Date(ts);
  return `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}.${d.getFullYear()}`;
};

/** Date + time: "05.01.2025, 14:30" */
export const formatDateTime = (ts: number | null): string => {
  if (!ts) return "";
  const d = new Date(ts);
  return `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}.${d.getFullYear()}, ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};

/** For datetime-local input value */
export const formatDateTimeLocal = (ts: number | null): string =>
  ts
    ? new Date(ts - new Date(ts).getTimezoneOffset() * 60000)
        .toISOString()
        .slice(0, 16)
    : "";

/** Parse datetime-local input value to timestamp */
export const parseDateTime = (val: string): number | null =>
  val ? new Date(val).getTime() : null;

// ─── Pagination helper ────────────────────────────────────────────────

export function pageNumbers(
  current: number,
  total: number,
  maxButtons = 15,
): (number | "...")[] {
  if (total <= maxButtons)
    return Array.from({ length: total }, (_, i) => i + 1);
  const pages: (number | "...")[] = [1];
  // Reserve slots for first, last, and up to 2 ellipses
  const wing = Math.max(1, Math.floor((maxButtons - 4) / 2));
  const lo = Math.max(2, current - wing);
  const hi = Math.min(total - 1, current + wing);
  if (lo > 2) pages.push("...");
  for (let i = lo; i <= hi; i++) pages.push(i);
  if (hi < total - 1) pages.push("...");
  pages.push(total);
  return pages;
}
